export default "__VITE_ASSET__CiSF1eW2__"